import { Link } from "react-router";

import PopoverWrapper from "./LinksListPopoverWrapper";

import "./LinksList.style.less";

const LinksList = ({ links }) => {
  if (!links?.length) return null;

  return (
    <ul className="links-list">
      {links.map(({ label, to, popover }) => (
        <li key={to}>
          <PopoverWrapper content={popover}>
            <Link to={to}>{label}</Link>
          </PopoverWrapper>
        </li>
      ))}
    </ul>
  );
};

export default LinksList;
